import { AuthBaseClient } from '../base-client';
import type { InvitationResponse, CreateInvitationRequest } from './types';
import type { SearchResponse } from '@vagusx/shared';

/**
 * Client for invitation API endpoints.
 */
export class InvitationClient extends AuthBaseClient {
  /**
   * List all invitations for the organization.
   */
  async list(): Promise<SearchResponse<InvitationResponse>> {
    return this.get<SearchResponse<InvitationResponse>>('/api/invitations');
  }

  /**
   * Create a new invitation.
   */
  async create(data: CreateInvitationRequest): Promise<InvitationResponse> {
    return this.post<InvitationResponse>('/api/invitations', data);
  }

  /**
   * Get invitation by token (public endpoint).
   */
  async getByToken(token: string): Promise<InvitationResponse> {
    return this.get<InvitationResponse>(`/api/invitations/token/${token}`);
  }

  /**
   * Delete/cancel an invitation.
   */
  async deleteInvitation(id: string): Promise<void> {
    return this.delete<void>(`/api/invitations/${id}`);
  }

  /**
   * Resend invitation email.
   */
  async resend(id: string): Promise<InvitationResponse> {
    return this.post<InvitationResponse>(`/api/invitations/${id}/resend`);
  }
}
